import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";

import Styles from "components/menu/BoxStatus.module.scss";
import { UiActions } from "state/actions/UiActions";
import { EditionUtils } from "utils/EditionUtils";
import { Modal } from "components/modal/Modal";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import ShippingsStyles from "components/menu/ShippingStatus.module.scss";
import { Row } from "components/grid/Row";
import { Col } from "components/grid/Col";

import { InfoLine } from "components/icons/InfoLine";
import { Utils } from "utils/Utils";
import { PossibleSubscriberIds, FilterSubscriberByEditions } from "core/utils/SubscriberUtils";
import { GlamboxSessionStore } from "core/glambox/GlamboxSessionStore";
import { AssinaturaRenovar } from 'components/assinatura/AssinaturaRenovar';

class BoxStatus extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentStatus: 5,
      minStatus: 1,
      maxStatus: null,
      currentEdition: null,
      hasTracking: null,
      modalInfo: false,
      modalShipping: false,
      shippingStatus: null,
      nextEdition: null,
      creditCardInfo: null,
      renewModalVisible: false,
      subscribers: null
    };
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.state.currentSubscriber
      !== this.props.state.currentSubscriber
    ) {
      this.setState({
        currentEdition: (this.props.state.currentSubscriber !== null)
          ? this.props.state.currentSubscriber.edition : null
      }, () => {
        this.loadData();
      });
    }else if(prevState.currentEdition
      !== this.state.currentEdition){
        this.loadData();
      }
  }

  loadData = () => {
    const {
      editions,
      subscribers
    } = this.props;
    let subscriberIdList = PossibleSubscriberIds(subscribers, true);
    let filteredEditions = FilterSubscriberByEditions(
      editions,
      subscriberIdList
    );

    if (this.state.currentEdition !== null && this.state.currentEdition !== undefined) {

      let current = this.state.currentEdition,
        trackingStatus,
        currentStatus;
      trackingStatus = EditionUtils.getTrackingStatus(
        current.editionId,
        current.manuallyReceivedEdition,
        current.editionStatusId
      );

      switch (trackingStatus.id) {
        case "confirmado": currentStatus = 1; break;
        case "montagem": currentStatus = 2; break;
        case "coletada": currentStatus = 3; break;
        case "emrota": currentStatus = 4; break;
        case "entregue": currentStatus = 5; break;
        default: currentStatus = 99; break;
      }

      this.setState({
        currentEdition: current,
        hasTracking: true,
        currentStatus,
        maxStatus: currentStatus
      });

      if (currentStatus >= 4) {
        this.loadShippingStatus(current);
      }
    } else {
      if (filteredEditions.glambox.length > 0) {
        let current = filteredEditions.glambox[0],
          trackingStatus,
          currentStatus;

        trackingStatus = EditionUtils.getTrackingStatus(
          current.editionId,
          current.manuallyReceivedEdition,
          current.editionStatusId
        );

        switch (trackingStatus.id) {
          case "confirmado": currentStatus = 1; break;
          case "montagem": currentStatus = 2; break;
          case "coletada": currentStatus = 3; break;
          case "emrota": currentStatus = 4; break;
          case "entregue": currentStatus = 5; break;
          default: currentStatus = 99; break;
        }

        this.setState({
          currentEdition: current || null,
          hasTracking: true,
          currentStatus,
          maxStatus: currentStatus
        });

        if (currentStatus >= 4) {
          this.loadShippingStatus(current);
        }
      } else {
        this.loadNextEdition();
      }
    }

    if (subscribers) {
      this.setState({
        subscribers: subscribers[0]
      })
    }

    if (this.state.subscribers) {
      this.getCreditCardInfo()
    }
  };

  loadNextEdition = () => {
    ExecuteRequest(
      GlamboxEndpoints.Open.nextEdition,
      {},
      "GET",
      null,
      null,
      (response) => {
        let {
          result,
          statusCode
        } = response;

        if (statusCode === 200) {
          this.setState({
            nextEdition: result
          });
        }
      }
    );
  }

  loadShippingStatus = (edition) => {
    let requestData = {
      shippingOrderId: edition.shippingOrderId
    };

    if (edition.shippingOrderId !== 0) {
      ExecuteRequest(
        GlamboxEndpoints.Logistics.shippingOrderTrackingStatus,
        null,//requestData,
        "GET",
        {
          Authorization: this.props.token.Authorization
        },
        requestData,//null,
        (response) => {
          let {
            result,
            statusCode
          } = response;

          if (statusCode === 200) {
            this.setState({
              shippingStatus: result
            });
          }
        }
      );
    }
  };

  _moveStatus = (direction) => {
    return () => {
      const { currentEdition } = this.state;
      const { editions } = this.props;

        let currentEditionIndex = editions.findIndex((edition) => {
          return edition.editionId === currentEdition.editionId
        });

        let newCurrentEdition = editions[currentEditionIndex - direction];

        this.setState({
          currentEdition: newCurrentEdition
        });


    }
  };

  _currentStatusTitle = () => {
    switch (this.state.currentStatus) {
      case 1:
        return "Confirmado";
      case 2:
        return "Montagem";
      case 3:
        return "Retirada";
      case 4:
        return "Em Rota";
      case 5:
        return "Entregue";
      default:
        return "Desconhecido";
    }
  };

  renderPrevButton = () => {
    let color = "#9da5ae";
    let disabled = false;

    let firstEdition = this.props.editions[this.props.editions.length - 1];
    if(this.state.currentEdition === firstEdition) {
      disabled = true;
      color = "#edf0f5";
    }
    //if (this.state.currentStatus > this.state.minStatus) color = "#9da5ae";

    return (
      <button disabled={disabled} onClick={this._moveStatus(-1)}>
        <svg width="6.678" height="11.012" viewBox="0 0 6.678 11.012">
          <path d="M14.369,11.011a1.364,1.364,0,0,0,.989-2.3L12.305,5.5l3.05-3.188A1.365,1.365,0,1,0,13.383.421L9.433,4.549a1.365,1.365,0,0,0,0,1.884l3.949,4.154A1.364,1.364,0,0,0,14.369,11.011Z" transform="translate(-9.055 0)" fill={color} />
        </svg>
      </button>
    );
  }

  renderNextButton = () => {
    //let color = "#edf0f5";
    // if (this.state.currentStatus < this.state.maxStatus) color = "#9da5ae";
    let color = "#9da5ae";
    let disabled = false;
    let lastEdition = this.props.editions[0];
    if(this.state.currentStatus === this.state.maxStatus && this.state.currentEdition === lastEdition) {
      color = "#edf0f5";
      disabled = true;
    }

    return (
      <button disabled={disabled} onClick={this._moveStatus(1)}>
        <svg width="6.678" height="11.012" viewBox="0 0 6.678 11.012">
          <path d="M10.419,11.011a1.364,1.364,0,0,1-.989-2.3L12.483,5.5,9.434,2.308A1.365,1.365,0,1,1,11.406.421l3.949,4.128a1.365,1.365,0,0,1,0,1.884l-3.949,4.154A1.364,1.364,0,0,1,10.419,11.011Z" transform="translate(-9.055 0)" fill={color} />
        </svg>
      </button>
    );
  }

  toggleModalInfo = () => {
    this.setState({
      modalInfo: !this.state.modalInfo
    });
  };

  toggleModalShipping = (e) => {
    if (e && e.preventDefault) e.preventDefault();

    this.setState({
      modalShipping: !this.state.modalShipping
    });
  };

  toggleRenewModal = () => {
    this.setState({
      renewModalVisible: !this.state.renewModalVisible,
    });
  };

  renderModalData = () => {
    let {
      currentStatus
    } = this.state;

    switch (currentStatus) {
      case 1:
        return (
          <div className={Styles["text-center"]}>
            <h5>{this._currentStatusTitle()}</h5>
            <p>
              <strong>Sua experiência Glambox já começou! Seu pedido está confirmado!</strong>
              Estamos escolhendo com carinho cada um dos produtos que irão na sua caixa e já já começaremos a montagem dela.
            </p>
            <button className={"btn btn-sm btn-light-lime"} onClick={this.toggleModalInfo}>
              Fechar
            </button>
          </div>
        );
      case 2:
        return (
          <div className={Styles["text-center"]}>
            <h5>{this._currentStatusTitle()}</h5>
            <p>
              <strong>A montagem da sua caixa já começou!</strong>
              Não se preocupe que você será avisada assim que ela for entregue à transportadora.
            </p>
            <button className={"btn btn-sm btn-light-lime"} onClick={this.toggleModalInfo}>
              Fechar
            </button>
          </div>
        );
      case 3:
        return (
          <div className={Styles["text-center"]}>
            <h5>{this._currentStatusTitle()}</h5>
            <p>
              <strong>Sua caixa está cada vez mais perto de você!</strong>
              A transportadora já recolheu e em breve estará a caminho! Agora, basta <strong>aguardar a liberação do código de rastreio</strong> e acompanhar a entrega.
            </p>
            <button className={"btn btn-sm btn-light-lime"} onClick={this.toggleModalInfo}>
              Fechar
            </button>
          </div>
        );
      case 4:
        return (
          <div className={Styles["text-center"]}>
            <h5>{this._currentStatusTitle()}</h5>
            <p>
              <strong>Prepare-se, sua Glambox já está a caminho!</strong>
              Em breve estará na sua casa! <a href={"#"} onClick={this.toggleModalShipping}>Clique aqui</a> para acompanhar as atualizações do processo de entrega.
            </p>
            <button className={"btn btn-sm btn-light-lime"} onClick={this.toggleModalInfo}>
              Fechar
            </button>
          </div>
        );
      case 5:
        return (
          <div className={Styles["text-center"]}>
            <h5>{this._currentStatusTitle()}</h5>
            <p>
              <strong>Fomos notificados pela transportadora que você recebeu sua Glambox!</strong>
              Aproveite muuuito os produtos, e até a próxima edição! Ah, não se esqueça também de passar o feedback da edição e dos produtos que você recebeu, é muito importante para nós e <strong>você ainda ganha glampoints!</strong>
            </p>
            <button className={"btn btn-sm btn-light-lime"} onClick={this.toggleModalInfo}>
              Fechar
            </button>
          </div>
        );
      default:
        return null;
    }
  };

  renderShippingModal = () => {
    let {
      shippingStatus,
      currentEdition
    } = this.state;

    if (shippingStatus === null || shippingStatus.length < 1) {
      return (
        <p>
          Status ainda não disponível.
        </p>
      );
    }

    return (
      <Row>
        <Col xs={12} lg={12} >
          <div>
            <h4>Informações de Rastreio: <span>{currentEdition.shippingServiceName} - {currentEdition.trackingCode}</span></h4>
            <div className={"level-2 " + ShippingsStyles["shipping-status"]}>
              <div className={ShippingsStyles["shipping-info__title"]} >
                <div>Código</div>
                <div>Data</div>
                <div>Status</div>
              </div>
              <div className={ShippingsStyles["shipping-info__content"]}>
                {this.renderShippingStatusTable()}
              </div>
            </div>
          </div>
        </Col>
      </Row>
    );
  };

  renderShippingStatusTable = () => {
    const { shippingStatus } = this.state;

    if (!shippingStatus || !Array.isArray(shippingStatus)) return null;
    return shippingStatus.map((item, key) => {

      return (
        <div className={ShippingsStyles["linhas"]} key={key}>
          <div>{item.trackingCode}</div>
          <div>{Utils.tempConvertDate(item.trackingStatusDate, true)}</div>
          <div>{item.trackingStatus}</div>
        </div>
      )

    });

  }

  getCreditCardInfo = async () => {
    let token = this.props.token.Authorization;
    let subscriber = this.props.subscribers[0];

    if (subscriber.id > 0) {
      await ExecuteRequest(
        GlamboxEndpoints.Subscriber.creditCard,
        {
          subscriberId: subscriber.id,
        },
        'GET',
        {
          Authorization: token,
        },
        null,
        (response) => {
          const { result, statusCode } = response;

          if (statusCode === 200) {
            this.setState({
              creditCardInfo: result,
            });
          }
        }
      );
    } else {
      return null;
    }
  };

  isGp = () => {
    let session = new GlamboxSessionStore();
    let isGp = session.get("isGlampartner");
    return isGp;
  }

  render() {
    const {
      currentEdition
    } = this.state;

    let statusClass = "status-" + this.state.currentStatus;
    let subscriber = this.props.subscribers[0];
    let person = this.props.person

    //if (this.state.nextEdition !== null) {
    let statuses = [4, 5, 14];
    if (
      this.props.person
      && !statuses.includes(this.props.person.personStatus)
      && this.state.nextEdition !== null
    ) {
      let editionDateName = EditionUtils.getEditionDateName(this.state.nextEdition.editionId, false, ' de ');
      return (
        <div className={"next__edition"}>
          <div className={"next__edition-image"}>
            <img src={"https://s3.amazonaws.com/Glambox.Content.MediaObject/Edition/" + this.state.nextEdition.editionId + "_boxEditionMenu.png"} alt={""} />
          </div>
          <div className={"next__edition-text text-center p-3"}>
            <small>{editionDateName}</small>
            <p className={"lead"}>{this.state.nextEdition.theme}</p>
            <a className={"btn btn-sm btn-light-lime"} target="_blank" href={"https://www.glambox.com.br/#planos"}>
              Assine!
            </a>
          </div>
        </div>
      );
    }

    if (!this.state.hasTracking || this.isGp()) return null;

    return (
      <div className={"d-flex " + Styles["box-status"]}>

        {(subscriber.subscriberStatus > 1 && subscriber.subscriberStatus < 5) && (
            <div className={Styles["div-reactive"]}>
              <a
                className={"btn btn-sm btn-light-lime " + Styles["btn-reactive"]}
                target="_blank"
                onClick={this.toggleRenewModal}>
                  Reativar
              </a>
            </div>
          )
        }

        <div className={Styles["box-status__infosContent"]}>
          <div className={Styles["box-status__infoButton"]} onClick={this.toggleModalInfo}>
            <InfoLine fill={"#008FFF"} />
          </div>
          <p className={Styles["box-status__small"]}>
            Status da sua caixa:<br />
            <strong>{currentEdition.theme}</strong>
          </p>


          <h5 style={{ cursor: "pointer" }} className={Styles["box-status__title"]} onClick={this.toggleModalInfo}>
            {this._currentStatusTitle()}
          </h5>

          <div className={Styles["box-status__progress"]}>
            <div className={classnames(Styles["box-status__progress-bar"], Styles[statusClass])}>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div className={Styles["box-status__progress-text"]}>
              {this.state.currentStatus} de 5
            </div>
          </div>
        </div>
        <div className={Styles["box-status__buttonsSlider"]}>
          {this.renderPrevButton()}
          {this.renderNextButton()}
        </div>
        {/*
        <div className={Styles["box-status__box-id"]}>
          <strong>{currentEdition.boxId}</strong>
        </div>
        */}

        <Modal visible={this.state.modalInfo} onCloseModal={this.toggleModalInfo} id={"status__modal"}>
          {this.renderModalData()}
        </Modal>

        <Modal visible={this.state.modalShipping} onCloseModal={this.toggleModalShipping} showCloseButton={true}>
          {this.renderShippingModal()}
        </Modal>

        <Modal
          visible={this.state.renewModalVisible}
          onCloseModal={this.toggleRenewModal}
          useDefaultDialog={false}
        >
          <AssinaturaRenovar
            creditCardInfo={this.state.creditCardInfo}
            subscriberId={subscriber.id}
            personId={person.id}
            onCancel={this.toggleRenewModal}
            onCloseModal={this.toggleRenewModal}
            callback={this.syncPayment}
          />
        </Modal>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ui: state.ui,
  token: state.token.data,
  person: state.person.data.person,
  editions: state.editions.data,
  subscribers: state.subscribers.data,
  state: state.state
});

const mapDispatchToProps = (dispatch) => ({
  closeMenu: () => {
    dispatch(UiActions.menuHide());
  }
});

BoxStatus = connect(
  mapStateToProps,
  mapDispatchToProps
)(BoxStatus);

export {
  BoxStatus
};
